function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { initAutoContextNotification } from "../common/auto-context-notification";
import { fetchAutoContextToasterService } from "./services/auto-context-toaster-service";
import { dispatchCustomerAutoContextFailureEvent, dispatchCustomerContextSuccessEvent, dispatchOpeningStoreChoicesModalEvent, dispatchOpenStoreContextLayerEvent } from "../common/event-bus";
import { getAutoContextHtml } from "./services/auto-context-service";
import { getContextBannerHtml } from "./services/context-banner-service";
import { getContextHeaderHtml } from "./services/context-header-service";
import { addContextHeaderEvent } from "../common/context-header-event";
import { addContextBannerEvent } from "../common/context-banner-event";
import { getRefreshedContextLayerView } from "./services/context-layer-service";
import { getRefreshedCustomerContextLayerView } from "./services/customer-context-layer-service";
var AutoContextualization = /*#__PURE__*/function (_lm$Composant) {
  function AutoContextualization(componentName) {
    var _this;
    _classCallCheck(this, AutoContextualization);
    _this = _callSuper(this, AutoContextualization, [componentName]);
    initAutoContextualization();
    return _this;
  }
  _inherits(AutoContextualization, _lm$Composant);
  return _createClass(AutoContextualization);
}(lm.Composant);
function initAutoContextualization() {
  var autoContextualizationSelector = getAutoContextualisationSelector();
  if (!autoContextualizationSelector) return;
  var isNotContextualizedAfterConsent = autoContextualizationSelector.dataset.isnotcontextualizedafterconsent === "true";
  var isOpeningModal = autoContextualizationSelector.dataset.isopeningmodal === "true";
  if (isNotContextualizedAfterConsent && isOpeningModal) {
    dispatchOpeningStoreChoicesModalEvent();
  }
  var isAutoContextualized = autoContextualizationSelector.dataset.isautocontextualized;
  if (isAutoContextualized == null) return;
  if (isAutoContextualized === "false") {
    handleAutoContextFail();
    return;
  }
  handleAutoContextSuccess();
}
function getAutoContextualisationSelector() {
  return document.querySelector("[data-selectorid=\"auto-contextualization\"]");
}
function getContextBannerSelector() {
  return document.querySelector("[data-selectorid=\"context-banner\"]");
}
function getContextHeaderSelector() {
  return document.querySelector("[data-selectorid=\"context-header\"]");
}
function getCustomerContextLayerSelector() {
  return document.querySelector("[data-selectorid=\"component-customer-context-layer\"]");
}
function getContextLayerSelector() {
  return document.querySelector("[data-selectorid=\"component-context-layer\"]");
}
function refreshContextBanner() {
  getContextBannerHtml(function (contextBannerFragment) {
    var contextBannerSelector = getContextBannerSelector();
    if (!contextBannerSelector) return;
    contextBannerSelector.outerHTML = contextBannerFragment;
    addContextBannerEvent();
  });
}
function refreshContextHeader() {
  getContextHeaderHtml(function (contextHeaderFragment) {
    var contextHeaderSelector = getContextHeaderSelector();
    if (!contextHeaderSelector) return;
    contextHeaderSelector.outerHTML = contextHeaderFragment;
    addContextHeaderEvent();
  });
}
function refreshCustomerContextLayer() {
  getRefreshedCustomerContextLayerView(function (customerContextLayerFragment) {
    var customerContextLayerSelector = getCustomerContextLayerSelector();
    if (!customerContextLayerSelector) return;
    customerContextLayerSelector.outerHTML = customerContextLayerFragment;
    window.dispatchEvent(new Event("refreshCustomerContextLayerJs"));
  });
}
function refreshContextLayer() {
  getRefreshedContextLayerView(function (contextLayerFragment) {
    var contextLayerSelector = getContextLayerSelector();
    if (!contextLayerSelector) return;
    contextLayerSelector.outerHTML = contextLayerFragment;
    window.dispatchEvent(new Event("refreshContextLayerJs"));
  });
}
export function refreshVisibleFragments() {
  refreshContextBanner();
  refreshContextHeader();
  refreshCustomerContextLayer();
  refreshContextLayer();
}
export function handleAutoContextSuccess() {
  dispatchCustomerContextSuccessEvent();
  var autoContextualizationSelector = getAutoContextualisationSelector();
  if (!autoContextualizationSelector) return;
  var reloadOnContextualizationSuccess = autoContextualizationSelector.dataset.reloadoncontextualizationsuccess === "true";
  if (reloadOnContextualizationSuccess) {
    var _autoContextualizatio, _autoContextualizatio2;
    window.location.replace((_autoContextualizatio2 = (_autoContextualizatio = autoContextualizationSelector.dataset).redirecturl) !== null && _autoContextualizatio2 !== void 0 ? _autoContextualizatio2 : _autoContextualizatio.redirecturl = window.location.href);
  } else {
    fetchAutoContextToasterService(function (toasterRendering) {
      autoContextualizationSelector.innerHTML = toasterRendering;
      var autoContextToaster = document.querySelector("[data-selectorid=\"auto-context-toaster\"]");
      initAutoContextNotification(autoContextToaster);
    });
  }
  refreshVisibleFragments();
}
export function handleAutoContextFail() {
  dispatchCustomerAutoContextFailureEvent();
  var autoContextualizationSelector = getAutoContextualisationSelector();
  if (!autoContextualizationSelector) return;
  var isOpeningLayer = autoContextualizationSelector.dataset.isopeninglayer === "true";
  var isOpeningModal = autoContextualizationSelector.dataset.isopeningmodal === "true";
  if (isOpeningLayer) dispatchOpenStoreContextLayerEvent();
  if (isOpeningModal) dispatchOpeningStoreChoicesModalEvent();
}
export function onUserConsentChange() {
  var optanonConsentCustomizationGroupValue = 'C0003:1';
  var cookieConsent = document.cookie.split(';').filter(function (cookie) {
    return cookie.trim().startsWith('OptanonConsent');
  }).values().next().value;
  decodeURIComponent(cookieConsent).includes(optanonConsentCustomizationGroupValue) ? refreshAutoContextFragment() : handleAutoContextFail();
}
function refreshAutoContextFragment() {
  getAutoContextHtml(function (autoContextFragment) {
    var autoContextualizationSelector = getAutoContextualisationSelector();
    if (!autoContextualizationSelector) return;
    autoContextualizationSelector.outerHTML = autoContextFragment;
    initAutoContextualization();
  }, handleAutoContextFail);
}
lm.DOMReady(function () {
  new AutoContextualization('autocontextualization');
});